// extracted by mini-css-extract-plugin
export default {"TableHeader":"ContentsTable_TableHeader__xrKge","Icon":"ContentsTable_Icon__jxiWf"};